import {Component, OnInit, ViewChild} from '@angular/core';
import {AppLayoutComponent, ClientAuthService, LanguageService, PLS_LANG_COOKIE} from '@proleis/proleis-web-app';
import {Store} from '@ngrx/store';
import {ProleisSuppliersState} from './modules/store/store.index';
import {TranslateService} from '@ngx-translate/core';
import {CookieService} from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  @ViewChild('layout') appLayout: AppLayoutComponent;

  isAuthenticated: boolean;
  title = 'proleis-suppliers';

  constructor(private store: Store<ProleisSuppliersState>, public clientAuth: ClientAuthService, private translate: TranslateService,
              private ls: LanguageService, private cookieService: CookieService) {
  }

  ngOnInit() {
    this.ls.loadLanguagesFromConfig();
    if (this.cookieService.get(PLS_LANG_COOKIE)){
      this.translate.setDefaultLang(this.cookieService.get(PLS_LANG_COOKIE));
    } else {
      this.translate.setDefaultLang('de');
    }
    this.ls.getSelectedLanguage().subscribe(language => {
      this.translate.use(language.code);
    });

    this.clientAuth.isAuthenticated$.subscribe(isAuthenticated => {
      this.isAuthenticated = isAuthenticated;
    });
  }

  toggleSidenav() {
  }
}
